import styled from '@emotion/styled'
import { MediaQueries } from '@hhgtech/hhg-components'

export const StyledOvulation = styled.div`
  min-height: 100vh;
  .article-bottom-ad {
    background-color: transparent;
    margin-bottom: var(--mobile-bottom-height);
    @supports (margin-bottom: env(safe-area-inset-bottom)) {
      margin-bottom: calc(
        env(safe-area-inset-bottom) + var(--mobile-bottom-height)
      );
    }
    ${MediaQueries.mbUp} {
      margin-bottom: 0px;
    }
  }
  .due-date-calculator-bottom-divider {
    border-width: 4px;
    border-color: #f7f9fc;
  }
  .other-healthtools-container {
    margin-bottom: 3rem;
  }
  .recalculate-container {
    display: flex;
    justify-content: center;
    button {
      padding: 0.5rem;
      font-weight: 600;
    }
  }

  ${MediaQueries.mbUp} {
    margin: 0 auto 32px auto;
  }
`
